/**
 * @fileoverview Description Component - Helper Text
 * 
 * @description
 * Componente para textos auxiliares e descrições com contraste garantido.
 * Ideal para hints de formulários, tooltips, e textos secundários.
 * 
 * @version 1.0 - Componentes Semânticos
 * @see PLANO_IMPLEMENTACAO_COMPLETO.md
 */

import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../../styles/design-tokens';

// ============================================================================
// TYPES
// ============================================================================

/**
 * Props do componente Description
 */
export interface DescriptionProps {
  /** Conteúdo da descrição */
  children: React.ReactNode;
  
  /** Classes CSS adicionais */
  className?: string;
  
  /** Texto de erro (muda cor para vermelho) */
  error?: boolean;
  
  /** Estilos customizados */
  sx?: React.CSSProperties;
}

// ============================================================================
// COMPONENT
// ============================================================================

/**
 * Componente Description - Textos auxiliares com contraste garantido
 * 
 * @example
 * ```tsx
 * <Description>
 *   Indicadores econômicos para cálculo do WACC
 * </Description>
 * 
 * <Description error>
 *   Taxa Selic deve estar entre 2% e 30%
 * </Description>
 * ```
 */
export function Description({
  children,
  className,
  error = false,
  sx,
}: DescriptionProps) {
  return (
    <Box
      component="p"
      className={className}
      sx={{
        // 🎨 CORREÇÃO: Contraste 7.2:1 (era 2.9:1 - muito claro)
        color: error ? colors.error.dark : colors.gray[600],  // #475569 - AAA ✅
        fontSize: '0.75rem',    // 12px
        fontWeight: 400,        // Normal
        lineHeight: 1.5,
        marginTop: '0.25rem',
        marginBottom: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

// ============================================================================
// EXPORT
// ============================================================================

export default Description;
